// Estimated far-field models, never substituted for manufacturer IES data.
// Smooth profiles use I(theta)=I0*cos(theta)^n over the forward hemisphere.
// Integrating I dOmega gives lumens exactly; beam is the full half-maximum
// angle, rather than the hard cutoff of the legacy uniform cone.
export const ESTIMATED_DISTRIBUTIONS = [
  ['uniform', 'Uniform cone · hard edge'],
  ['panel', 'Diffuse panel · smooth spread'],
  ['diffuser', 'Ceiling diffuser · smooth spread'],
  ['highbay', 'High-bay · smooth beam']
];
export const smoothDistribution = d => ['panel','diffuser','highbay'].includes(d.distribution);
export const distributionExponent = d => Math.log(.5)/Math.log(Math.cos(Math.min(179.9,d.beam||120)*Math.PI/360));
export function estimatedPeak(d) {
  return smoothDistribution(d)?d.lumens*(distributionExponent(d)+1)/(2*Math.PI):d.lumens/(2*Math.PI*(1-Math.cos(d.beam*Math.PI/360)));
}
export function estimatedCandela(d, theta) {
  if(smoothDistribution(d))return theta>=90?0:estimatedPeak(d)*Math.max(0,Math.cos(theta*Math.PI/180))**distributionExponent(d);
  return theta<=d.beam/2?estimatedPeak(d):0;
}
